import { gql } from "@apollo/client";

export const DISCOVER_OUR_SERVICES = gql`
  query discoverOurServices {
    servicesdata {
      title
      position
      image
      social_url
      content
      content_type
      status
    }
  }
`;

export const CONTACT_US = gql`
  mutation contactUs(
    $fullname: String!
    $email: String!
    $sirname: String!
    $subject: String!
    $message: String!
    $type: String!
    $phone: String
    $pincode: String
    $product_name: String
    $g_captcha_response: String!
    $utm_id: String
    $utm_source: String
    $utm_medium: String
    $utm_content: String
    $utm_campaign: String
    $utm_city: String
    $utm_term: String
    $device: String
  ) {
    contactusFormSubmit(
      input: {
        fullname: $fullname
        email: $email
        sirname: $sirname
        subject: $subject
        message: $message
        phone: $phone
        solution: ""
        numberofemp: "0"
        status: 1
        type: $type
        pincode: $pincode
        product_name: $product_name
        g_captcha_response: $g_captcha_response
        utm_id: $utm_id
        utm_source: $utm_source
        utm_medium: $utm_medium
        utm_content: $utm_content
        utm_campaign: $utm_campaign
        utm_city: $utm_city
        utm_term: $utm_term
        device: $device
      }
    ) {
      success_message
    }
  }
`;

export const FREE_DESIGN_FORM = gql`
  mutation freeDesignForm(
    $fullname: String!
    $email: String!
    $message: String!
    $type: String!
    $phone: String!
    $city: String!
    $pincode: String!
    $g_captcha_response: String!
    $houseNo: String!
    $areaName: String!
    $landmark: String!
  ) {
    contactusFormSubmit(
      input: {
        fullname: $fullname
        type: $type
        email: $email
        phone: $phone
        message: $message
        location: $pincode
        city: $city
        g_captcha_response: $g_captcha_response
        house_no: $houseNo
        area_name: $areaName
        landmark: $landmark
      }
    ) {
      success_message
    }
  }
`;

export const TECHNICAL_ASSISTANCE_FORM = gql`
  mutation technicalForm(
    $fullname: String!
    $email: String!
    $message: String!
    $type: String!
    $phone: String!
    $productCategory: String!
    $productName: String!
    $pincode: String!
    $city: String!
    $g_captcha_response: String!
    $houseNo: String!
    $areaName: String!
    $landmark: String!
  ) {
    contactusFormSubmit(
      input: {
        fullname: $fullname
        phone: $phone
        type: $type
        email: $email
        message: $message
        product_category: $productCategory
        product_name: $productName
        location: $pincode
        city: $city
        g_captcha_response: $g_captcha_response
        house_no: $houseNo
        area_name: $areaName
        landmark: $landmark
      }
    ) {
      success_message
    }
  }
`;

export const INSTALLATION_FORM = gql`
  mutation installationForm(
    $fullname: String!
    $email: String!
    $message: String!
    $type: String!
    $phone: String!
    $sourceOfPurchase: String!
    $productPurchased: String!
    $invoice: String!
    $pincode: String!
    $city: String!
    $g_captcha_response: String!
    $houseNo: String!
    $areaName: String!
    $landmark: String!
  ) {
    contactusFormSubmit(
      input: {
        fullname: $fullname
        phone: $phone
        type: $type
        email: $email
        product_name: $productPurchased
        source_of_purchase: $sourceOfPurchase
        invoice: $invoice
        message: $message
        location: $pincode
        city: $city
        g_captcha_response: $g_captcha_response
        house_no: $houseNo
        area_name: $areaName
        landmark: $landmark
      }
    ) {
      success_message
    }
  }
`;

export const UPLOAD_INVOICE = gql`
  mutation uploadInvoice(
    $name: String!
    $savePath: String!
    $base64Value: String!
  ) {
    hkUploadFiles(
      input: {
        name: $name
        save_path: $savePath
        base64_encoded_file: $base64Value
      }
    ) {
      items {
        name
        full_path
        file_path
      }
    }
  }
`;

export const FIND_CITIES = gql`
  query findCities($input: String!) {
    cities(keyword: $input) {
      items {
        pincode
        city
        state_name
      }
    }
  }
`;
